import React, { useState, useMemo } from 'react';
import { Box } from '@mui/material';
import { useMenuStore } from '../../stores/menuStore.js';
import { MenuSearchHeader } from '../home/MenuSearchHeader.jsx';
import { MobileMenuGrid } from './MobileMenuGrid.jsx';

/**
 * Mobile Home tab — the default tab after login.
 * Shows the menu items grid (3 per row) with search & category filters.
 */
export const MobileHomeTab = () => {
  const { items, menus, selectedMenuId, setSelectedMenu, isLoading: menuLoading } = useMenuStore();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  const handleMenuChange = (menuId) => {
    setSelectedMenu(menuId);
    setSelectedCategory('All');
    setSearchQuery('');
  };

  const categories = useMemo(() => {
    const catSet = new Set();
    items.forEach((item) => {
      (item.category || []).forEach((c) => {
        if (c && typeof c === 'string' && c.trim()) catSet.add(c.trim());
      });
      (item.category2 || []).forEach((c) => {
        if (c && typeof c === 'string' && c.trim()) catSet.add(c.trim());
      });
    });
    return ['All', ...Array.from(catSet).sort()];
  }, [items]);

  const filteredItems = useMemo(() => {
    return items.filter((item) => {
      const matchesCategory =
        selectedCategory === 'All' ||
        (item.category || []).some(
          (c) => typeof c === 'string' && c.toLowerCase() === selectedCategory.toLowerCase()
        ) ||
        (item.category2 || []).some(
          (c) => typeof c === 'string' && c.toLowerCase() === selectedCategory.toLowerCase()
        );
      const matchesSearch =
        !searchQuery || item.name.toLowerCase().includes(searchQuery.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [items, selectedCategory, searchQuery]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
      <Box sx={{ flexShrink: 0 }}>
        <MenuSearchHeader
          menus={menus}
          selectedMenuId={selectedMenuId}
          onMenuChange={handleMenuChange}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          categories={categories}
          selectedCategory={selectedCategory}
          onCategoryChange={setSelectedCategory}
        />
      </Box>
      <MobileMenuGrid
        filteredItems={filteredItems}
        isLoading={menuLoading}
        searchQuery={searchQuery}
        hasItems={items.length > 0}
        onClearFilters={() => {
          setSearchQuery('');
          setSelectedCategory('All');
        }}
      />
    </Box>
  );
};
